import { Link, useRouteLoaderData } from '@remix-run/react'
import { useTranslation } from 'react-i18next'
import { type loader as rootLoader } from '#app/root.tsx'
import { LanguageSwitch } from '#app/routes/resources+/locale-switch.tsx'
import { ThemeSwitch } from '#app/routes/resources+/theme-switch.tsx'
import { Logo } from '#app/ui/components/custom/logo.tsx'
import { Container } from '#app/ui/components/layout/container.tsx'
import { useOptionalUser } from '#app/utils/user.js'
import { UserDropdown } from '../patterns/user-dropdown'

export const Header = () => {
	const data = useRouteLoaderData<typeof rootLoader>('root')!
	const user = useOptionalUser()
	const { t } = useTranslation()

	return (
		<Container>
			<header className="py-6">
				<nav className="flex flex-wrap items-center justify-between gap-4 sm:flex-nowrap md:gap-8">
					<Logo />
					<div className="flex items-center gap-4 sm:gap-8">
						<Link
							to="/call"
							className="text-sm font-medium text-muted-700 hover:text-foreground"
						>
							{t('nav.bookCall')}
						</Link>
						<LanguageSwitch
							userPreference={data.requestInfo.userPrefs.locale}
						/>
						<ThemeSwitch userPreference={data.requestInfo.userPrefs.theme} />
						{user ? <UserDropdown /> : null}
					</div>
				</nav>
			</header>
		</Container>
	)
}
